<template>
    <div>
        <v-btn color="primary"
               fab
               dark
               fixed
               bottom
               style="z-index: 99999;"
               @click.stop="drawer = !drawer"
               right>
            <v-icon>mdi-filter</v-icon>
        </v-btn>

        <v-container class="pa-0">

            <v-navigation-drawer v-model="drawer"
                                 fixed
                                 floating
                                 style="z-index:9999;"
                                 right
                                 app>

                <v-list-item nav dense>
                    <v-list-item-content>
                        <v-list-item-title><label><v-icon>mdi-filter</v-icon> Report Filter</label></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>


                <v-radio-group v-model="reportFilter.reportDateType" class="pl-3 pt-2" mandatory>
                    <v-radio label="Incident Start Date" :value="0"></v-radio>
                    <v-radio label="Incident Handled Date" :value="1"></v-radio>
                </v-radio-group>

                <v-list dense class="pa-0 pt-3">
                    <v-list-item>
                        <v-list-item-content class="pa-0">
                            <v-dialog ref="dialogStartDate"
                                      v-model="modalStartDate"
                                      :return-value.sync="reportFilter.startDate"
                                      persistent
                                      width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="reportFilter.startDate"
                                                  label="Start Date"
                                                  prepend-icon="mdi-calendar"
                                                  readonly
                                                  v-bind="attrs"
                                                  v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="reportFilter.startDate"
                                               scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text
                                           color="primary"
                                           @click="modalStartDate = false">
                                        Cancel
                                    </v-btn>
                                    <v-btn text
                                           color="primary"
                                           @click="$refs.dialogStartDate.save(reportFilter.startDate)">
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>


                <v-list dense class="pa-0">
                    <v-list-item>
                        <v-list-item-content class="pa-0">
                            <v-dialog ref="dialogStartTime"
                                      v-model="modalStartTime"
                                      :return-value.sync="reportFilter.startTime"
                                      persistent
                                      width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="reportFilter.startTime"
                                                  label="Start Time"
                                                  prepend-icon="mdi-clock-time-four-outline"
                                                  readonly
                                                  v-bind="attrs"
                                                  v-on="on"></v-text-field>
                                </template>
                                <v-time-picker v-if="modalStartTime"
                                               v-model="reportFilter.startTime"
                                               full-width>
                                    <v-spacer></v-spacer>
                                    <v-btn text
                                           color="primary"
                                           @click="modalStartTime = false">
                                        Cancel
                                    </v-btn>
                                    <v-btn text
                                           color="primary"
                                           @click="$refs.dialogStartTime.save(reportFilter.startTime)">
                                        OK
                                    </v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list dense class="pa-0">
                    <v-list-item>
                        <v-list-item-content class="pa-0">
                            <v-dialog ref="dialogEndDate"
                                      v-model="modalEndDate"
                                      :return-value.sync="reportFilter.endDate"
                                      persistent
                                      width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="reportFilter.endDate"
                                                  label="End Date"
                                                  prepend-icon="mdi-calendar"
                                                  readonly
                                                  v-bind="attrs"
                                                  v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="reportFilter.endDate"
                                               scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text
                                           color="primary"
                                           @click="modalEndDate = false">
                                        Cancel
                                    </v-btn>
                                    <v-btn text
                                           color="primary"
                                           @click="$refs.dialogEndDate.save(reportFilter.endDate)">
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list dense class="pa-0">
                    <v-list-item>
                        <v-list-item-content class="pa-0">
                            <v-dialog ref="dialogEndTime"
                                      v-model="modalEndTime"
                                      :return-value.sync="reportFilter.endTime"
                                      persistent
                                      width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="reportFilter.endTime"
                                                  label="End Time"
                                                  prepend-icon="mdi-clock-time-four-outline"
                                                  readonly
                                                  v-bind="attrs"
                                                  v-on="on"></v-text-field>
                                </template>
                                <v-time-picker v-if="modalEndTime"
                                               v-model="reportFilter.endTime"
                                               full-width>
                                    <v-spacer></v-spacer>
                                    <v-btn text
                                           color="primary"
                                           @click="modalEndTime = false">
                                        Cancel
                                    </v-btn>
                                    <v-btn text
                                           color="primary"
                                           @click="$refs.dialogEndTime.save(reportFilter.endTime)">
                                        OK
                                    </v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list dense class="pa-0">
                    <v-list-item>
                        <v-list-item-content class="pa-0">
                            <v-select v-model="reportFilter.selectedOperatorBrands"
                                      :items="operatorBrands"
                                      v-if="showOperatorFilter || reportFilter.selectedOperatorBrands.length > 0"
                                      chips
                                      item-text="name"
                                      item-value="name"
                                      persistent-hint
                                      label="Select Operator"
                                      hint="Filter reports by specific operators"
                                      multiple>
                                <template v-slot:prepend-item>
                                    <v-list-item ripple
                                                 @click="toggleOperatorFilters">
                                        <v-list-item-action>
                                            <v-icon :color="reportFilter.selectedOperatorBrands.length > 0 ? 'primary darken-4' : ''">
                                                {{ sourceOperatorIcon }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select All
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>

                            </v-select>

                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list dense class="pa-0">
                    <v-list-item>
                        <v-list-item-content class="pa-0">
                            <v-select v-model="reportFilter.selectedIncidentTypes"
                                      :items="incidentTypes"
                                      v-if="showIncidentTypeFilter || reportFilter.selectedIncidentTypes.length > 0"
                                      chips
                                      item-text="name"
                                      item-value="name"
                                      persistent-hint
                                      label="Select Severity"
                                      hint="Filter reports by specific severity"
                                      multiple>
                                <template v-slot:prepend-item>
                                    <v-list-item ripple
                                                 @click="toggleIncidentTypeFilters">
                                        <v-list-item-action>
                                            <v-icon :color="reportFilter.selectedIncidentTypes.length > 0 ? 'primary darken-4' : ''">
                                                {{ sourceIncidentTypeIcon }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select All
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>

                            </v-select>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list dense class="pa-0">
                    <v-list-item>
                        <v-list-item-content class="pa-0">
                            <v-select v-model="reportFilter.selectedSites"
                                      v-if="showSiteFilter || reportFilter.selectedSites.length > 0"
                                      :items="sites"
                                      chips
                                      item-text="name"
                                      item-value="name"
                                      persistent-hint
                                      label="Select Sites"
                                      hint="Filter reports by specific sites"
                                      multiple>
                                <template v-slot:prepend-item>
                                    <v-list-item ripple
                                                 @click="toggleSiteFilters">
                                        <v-list-item-action>
                                            <v-icon :color="reportFilter.selectedSites.length > 0 ? 'primary darken-4' : ''">
                                                {{ siteIcon }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select All
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>

                            </v-select>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list dense class="pa-0">
                    <v-list-item>
                        <v-list-item-content class="pa-0">
                            <v-select v-model="reportFilter.selectedResponsibleTeams"
                                      :items="responsibleTeams"
                                      v-if="showResponsibleTeamFilter || reportFilter.selectedResponsibleTeams.length > 0"
                                      chips
                                      item-text="name"
                                      item-value="name"
                                      persistent-hint
                                      label="Select Responsible Team"
                                      hint="Filter reports by specific responsible team"
                                      multiple>
                                <template v-slot:prepend-item>
                                    <v-list-item ripple
                                                 @click="toggleResponsibleTeamFilters">
                                        <v-list-item-action>
                                            <v-icon :color="reportFilter.selectedIncidentTypes.length > 0 ? 'primary darken-4' : ''">
                                                {{ sourceResponsibleTeamIcon }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select All
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>

                            </v-select>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

            </v-navigation-drawer>


        </v-container>
    </div>
</template>

<script>
    import OperatorService from "../../services/operatorService"
    import ReportService from "../../services/reportService"
    import ReportTableService from "../../services/reportTableService"
    import moment from 'moment';

    export default {
        name: 'ReportFilter',
        data: function () {
            return {
                accessToken: null,
                modalStartDate: false,
                modalEndDate: false,
                modalStartTime: false,
                modalEndTime: false,
                operatorBrands: [],
                incidentTypes: [],
                sites: [],
                responsibleTeams: [],
                panel: [0, 1],
                drawer: false,
                reportFilter: this.reportFilterOverride
            }
        },
        watch: {
            deep: true,
            immediate: true,
            "reportFilter.selectedOperatorBrands": {
                handler() {
                    this.onSelectedOperatorChanged()
                },
                deep: true,
                immediate: true,
            },
        },
        props: {
            showOperatorFilter: {
                default: true,
                type: Boolean
            },
            showSiteFilter: {
                default: true,
                type: Boolean
            },
            showIncidentTypeFilter: {
                default: true,
                type: Boolean
            },
            showResponsibleTeamFilter: {
                default: true,
                type: Boolean
            },
            reportFilterOverride: {
                default() {
                    return {
                        reportDateType: 0,
                        startDate: moment().subtract(1, "days").format(moment.HTML5_FMT.DATE),
                        startTime: "00:00",
                        endDate: moment().format(moment.HTML5_FMT.DATE),
                        endTime: "23:59",
                        selectedOperatorBrands: [],
                        selectedIncidentTypes: [],
                        selectedSites: [],
                        selectedResponsibleTeams: []
                    }
                },
                type: Object
            },
        },
        computed: {
            //operator
            operatorAllOptions() {
                return this.reportFilter.selectedOperatorBrands.length === this.operatorBrands.length
            },
            operatorSomeOptions() {
                return this.reportFilter.selectedOperatorBrands.length > 0 && !this.operatorAllOptions;
            },
            sourceOperatorIcon() {
                if (this.operatorAllOptions) return 'mdi-close-box'
                if (this.operatorSomeOptions) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
            //responsibleTeams
            responsibleTeamAllOptions() {
                return this.reportFilter.selectedResponsibleTeams.length === this.responsibleTeams.length;
            },
            responsibleTeamSomeOptions() {
                return this.reportFilter.selectedResponsibleTeams.length > 0 && !this.responsibleTeamAllOptions;
            },
            sourceResponsibleTeamIcon() {
                if (this.responsibleTeamAllOptions) return 'mdi-close-box'
                if (this.responsibleTeamSomeOptions) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
            //incidentType
            incidentTypeAllOptions() {
                return this.reportFilter.selectedIncidentTypes.length === this.incidentTypes.length
            },
            incidentTypeSomeOptions() {
                return this.reportFilter.selectedIncidentTypes.length > 0 && !this.incidentTypeAllOptions;
            },
            sourceIncidentTypeIcon() {
                if (this.incidentTypeAllOptions) return 'mdi-close-box'
                if (this.incidentTypeSomeOptions) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
            //site
            siteAllOptions() {
                return this.reportFilter.selectedSites.length === this.sites.length
            },
            siteSomeOptions() {
                return this.reportFilter.selectedSites.length > 0 && !this.siteAllOptions
            },
            siteIcon() {
                if (this.siteAllOptions) return 'mdi-close-box'
                if (this.siteSomeOptions) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
        },
        created() {
            this.setup();
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
                await this.getUserOperatorBrands();
                await this.getIncidentTypes();
                await this.getAllSites();
                await this.getResponsibleTeams();
            },
            async getUserOperatorBrands() {
                const brands = await OperatorService.getUserOperatorBrands(this.accessToken);

                if (brands !== null && brands.length > 0) {
                    this.operatorBrands = brands.map((brand) => brand.name);
                }
            },
            getOperatorBrands() {
                return this.operatorBrands;
            },
            toggleOperatorFilters() {
                this.$nextTick(() => {
                    if (this.operatorAllOptions) {
                        this.reportFilter.selectedOperatorBrands = []
                    } else {
                        this.reportFilter.selectedOperatorBrands = this.operatorBrands.slice()
                    }
                })
            },
            toggleIncidentTypeFilters() {
                this.$nextTick(() => {
                    if (this.incidentTypeAllOptions) {
                        this.reportFilter.selectedIncidentTypes = []
                    } else {
                        this.reportFilter.selectedIncidentTypes = this.incidentTypes.slice()
                    }
                })
            },
            toggleSiteFilters() {
                this.$nextTick(() => {
                    if (this.siteAllOptions) {
                        this.reportFilter.selectedSites = []
                    } else {
                        this.reportFilter.selectedSites = this.sites.slice()
                    }
                })
            },
            toggleResponsibleTeamFilters() {
                this.$nextTick(() => {
                    if (this.responsibleTeamAllOptions) {
                        this.reportFilter.selectedResponsibleTeams = []
                    } else {
                        this.reportFilter.selectedResponsibleTeams = this.reponsibleTeams.slice()
                    }
                })
            },
            async getIncidentTypes() {

                const cachedIncidentTypes = localStorage.getItem('incidentTypes');

                if (cachedIncidentTypes) {
                    this.incidentTypes = JSON.parse(cachedIncidentTypes);
                    return;
                }

                let columns = await ReportTableService.searchReportTableColumns(
                    "",
                    "",
                    1,
                    100,
                    "FriendlyName",
                    "ASCENDING",
                    this.accessToken);

                let column = columns.data.find(column => column.columnName === "IncidentSeverity");
                if (column) {
                    let results = await ReportService.getUniqueSourceItems(column.id, this.accessToken);

                    results.forEach((item) => {
                        if (item !== "0" && item !== "BCC" && item !== "Security A" && item !== "Security B" && item !== "Security C" && item !== "Security D" && item !== "Severity D") {
                            this.incidentTypes.push(item);
                        }
                    })
                }

                const parsed = JSON.stringify(this.incidentTypes);
                localStorage.setItem('incidentTypes', parsed);
            },
            async getResponsibleTeams() {

                const cachedResponsibleTeams = localStorage.getItem('responsibleTeams');

                if (cachedResponsibleTeams) {
                    this.responsibleTeams = JSON.parse(cachedResponsibleTeams);
                    return;
                }

                let columns = await ReportTableService.searchReportTableColumns(
                    "",
                    "",
                    1,
                    100,
                    "FriendlyName",
                    "ASCENDING",
                    this.accessToken);

                let column = columns.data.find(column => column.columnName === "ResponsibleTeam");
                if (column) {
                    let results = await ReportService.getUniqueSourceItems(column.id, this.accessToken);

                    this.responsibleTeams = [];

                    results.forEach((item) => {
                        if (item && item !== "" && item !== " ") {
                            this.responsibleTeams.push(item);
                        }
                    })
                }

                const parsed = JSON.stringify(this.responsibleTeams);
                localStorage.setItem('responsibleTeams', parsed);
            },
            //this is purely a additional requirment that I cant argue with it simply "has to be done by business
            async onSelectedOperatorChanged() {

                if (this.reportFilter.selectedOperatorBrands &&
                    this.reportFilter.selectedOperatorBrands.length === 1 &&
                    this.reportFilter.selectedOperatorBrands.some(x => x === "DOS")) {
                    const filterdSites = this.sites.filter(x => x !== "GIC" && x !== "32 Red (Gibraltar)" && x !== "Gibraltar (C8)" && x !== "32 Red - GIB");
                    this.reportFilter.selectedSites = filterdSites;
                }

            },
            async getAllSites() {
                const cachedAffectedSites= localStorage.getItem('affectedSites');

                if (cachedAffectedSites) {
                    this.sites = JSON.parse(cachedAffectedSites);
                    return;
                }

                let columns = await ReportTableService.searchReportTableColumns(
                    "",
                    "",
                    1,
                    100,
                    "FriendlyName",
                    "ASCENDING",
                    this.accessToken);

                let column = columns.data.find(column => column.columnName === "AffectedSite");
                if (column) {
                    let results = await ReportService.getUniqueSourceItems(column.id, this.accessToken);

                    this.sites = [];

                    results.forEach((item) => {
                        if (item && item !== "" && item !== "All" && item !== "n\\/a") {
                            this.sites.push(item);
                        }
                    });

                }

                const parsed = JSON.stringify(this.sites);
                localStorage.setItem('affectedSites', parsed);
            }
        },
    }
</script>
